import { useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { AppLayout } from "@/components/layout/AppLayout";
import { FullscreenLayout } from "@/components/layout/FullscreenLayout";
import { GuestRoute } from "@/components/layout/GuestRoute";
import { LoginPage } from "@/pages/LoginPage";
import { OnboardingPage } from "@/pages/OnboardingPage";
import { DashboardPage } from "@/pages/DashboardPage";
import { AlertsPage } from "@/pages/AlertsPage";
import { AlertDetailPage } from "@/pages/AlertDetailPage";
import { WatchlistPage } from "@/pages/WatchlistPage";
import { SettingsPage } from "@/pages/SettingsPage";
import { ScrapePage } from "@/pages/ScrapePage";
import { ChatPage } from "@/pages/ChatPage";
import { IntelligencePage } from "@/pages/IntelligencePage";
import { OAuthCallbackPage } from "@/pages/OAuthCallbackPage";
import { KycPage } from "@/pages/KycPage";
import { EmailIntelligencePage } from "@/pages/EmailIntelligencePage";
import { CompetitorDetailPage } from "@/pages/CompetitorDetailPage";
import { InvitePage } from "@/pages/InvitePage";
import { SocialPage } from "@/pages/admin/SocialPage";
import { IntegrationCallbackPage } from "@/pages/IntegrationCallbackPage";
import { UpgradeDialog } from "@/components/billing/UpgradeDialog";
// import { CmoPage } from "@/pages/CmoPage"; // hidden — coming soon

function SignupRedirect() {
  const contactUrl = "https://peersheep.com/contact";
  useEffect(() => {
    window.location.replace(contactUrl);
  }, []);

  return <a href={contactUrl}>Continue to Peersheep contact</a>;
}

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        {/* Public */}
        <Route path="/login" element={<GuestRoute><LoginPage /></GuestRoute>} />
        <Route path="/signup" element={<SignupRedirect />} />
        <Route path="/auth/callback" element={<OAuthCallbackPage />} />
        <Route path="/onboarding" element={<OnboardingPage />} />
        <Route path="/invite/:token" element={<InvitePage />} />

        {/* App — with sidebar */}
        <Route element={<AppLayout />}>
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/alerts" element={<AlertsPage />} />
          <Route path="/alerts/:id" element={<AlertDetailPage />} />
          <Route path="/competitors/:id" element={<CompetitorDetailPage />} />
          <Route path="/watchlist" element={<WatchlistPage />} />
          <Route path="/intelligence" element={<IntelligencePage />} />
          <Route path="/know-your-competitors" element={<KycPage />} />
          <Route path="/kyc" element={<Navigate to="/know-your-competitors" replace />} />
          <Route path="/email-intelligence" element={<EmailIntelligencePage />} />
          <Route path="/email-intelligence/callback" element={<EmailIntelligencePage />} />
          <Route path="/chat" element={<ChatPage />} />
          <Route path="/chat/:sessionId" element={<ChatPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/integrations/callback" element={<IntegrationCallbackPage />} />
          <Route path="/admin/social" element={<SocialPage />} />
          <Route path="/admin/social/callback" element={<SocialPage />} />
        </Route>

        {/* Fullscreen — no sidebar */}
        <Route element={<FullscreenLayout />}>
          <Route path="/scrape" element={<ScrapePage />} />
          {/* <Route path="/cmo" element={<CmoPage />} /> */}
        </Route>

        {/* Default */}
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
      {/* Opens on plan limits and out-of-credit errors from any page */}
      <UpgradeDialog />
    </AuthProvider>
  );
}
